module.exports = __webpack_public_path__ + "peytilvideo.jpg?c6e9b8c74e5e5bf4f40dbbcd0a2f59bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/peytilvideo.jpg
// module id = 1073
// module chunks = 0